<script lang="ts">
  export let classes: string = "h-6 w-6";
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  class={classes}
  fill="none"
  viewBox="0 0 24 24"
  stroke="currentColor"
>
  <path
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    d="M9 5l7 7-7 7"
  />
</svg>
